"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySuggestionType = void 0;
var QuerySuggestionType;
(function (QuerySuggestionType) {
    QuerySuggestionType["Product"] = "product";
    QuerySuggestionType["Page"] = "page";
})(QuerySuggestionType = exports.QuerySuggestionType || (exports.QuerySuggestionType = {}));
//# sourceMappingURL=querySuggestionType.js.map